import { useEffect } from "react";
import { SALON } from "../data/salon";

/**
 * Sets the document title for a route. Every page owns its own title so the
 * tab, the bookmark and the search result each say which page they are —
 * index.html only carries the homepage default.
 */
export function useDocumentTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} | ${SALON.name}` : `${SALON.name} | ${SALON.tagline}`;
  }, [title]);
}
